// extracted by mini-css-extract-plugin
module.exports =  {"segment":"DYOsC12L2FsTwX_a34zB","empty":"EFkuO7TEXuftZqMYeLA_","cardActions":"zFzZdzJguhF7jVYwYImy","recipientCount":"OZ8zFNtg8wRCfpra_MEp","tooltipIcon":"GDt66ng1j2lb0ZSV9PdB"};